
import { IBodyRequest, IBodyResponse, IBodyResponseOrderListItems, IBodyResponseOrdersList, IBodyResponseOrdersListSum } from 'interfaces/remaining';
import { addRouteParam, IHttpResponse, serverAxios } from '../../http';

class RemainingHttp {
  private static route = 'financial_history/list/V2';
  private static export = 'financial_history/export/v2';
  private static routeOrders = 'financial_history/orders-remaining';
  private static listItems = 'financial_history/orders-remaining/:id/items';
  private static listItemsSum = 'financial_history/orders-remaining/total';
  private static exportV3 = 'financial_history/orders-remaining/export';

  public async getList(param: IBodyRequest): Promise<IHttpResponse<IBodyResponse>> {
    return serverAxios.get(RemainingHttp.route, { params: param });
  }
  public async export(param: IBodyRequest): Promise<IHttpResponse<Blob>> {
    return serverAxios.get(RemainingHttp.export, { params: param, responseType: 'blob' });
  }

  public async exportV3(param: IBodyRequest): Promise<IHttpResponse<Blob>> {
    return serverAxios.get(RemainingHttp.exportV3, { params: param, responseType: 'blob' });
  }

  public async getListOrders(param: IBodyRequest): Promise<IHttpResponse<IBodyResponseOrdersList>> {
    return serverAxios.get(RemainingHttp.routeOrders, { params: param });
  }

  public async getListOrder(id: string, param: IBodyRequest): Promise<IHttpResponse<IBodyResponseOrderListItems>> {
    return serverAxios.get(addRouteParam(RemainingHttp.listItems, { id }), { params: param });
  }

  public async getListOrdersSum(param: IBodyRequest): Promise<IHttpResponse<IBodyResponseOrdersListSum>> {
    return serverAxios.get(RemainingHttp.listItemsSum, { params: param });
  }


}

export default RemainingHttp;
